var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71429 2V14.7586M30.2857 2V14.7586M8.42857 21.1379H16.1429M31.5714 21.1379H23.8571M8.42857 28.7931H16.1429M23.8571 28.7931H31.5714M4.57143 8.37931H35.4286C36.8488 8.37931 38 9.52177 38 10.931V36.4483C38 37.8576 36.8488 39 35.4286 39H4.57143C3.15127 39 2 37.8576 2 36.4483V10.931C2 9.52177 3.15127 8.37931 4.57143 8.37931Z",
    stroke: "#353535",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV1);
export default __webpack_public_path__ + "static/media/v1.231233017931d9386352ee56d2068bf8.svg";
export { ForwardRef as ReactComponent };